import { Validator } from '@vista-digital/validator';
import { InvalidFieldNameError } from '../../../types/invalid-field-name-error';
import { customerDetailsFormFieldDisplayTextValidator, defaultCustomerDetailsEmailFormFieldDisplayText, defaultCustomerDetailsFamilyNameFormFieldDisplayText, defaultCustomerDetailsGivenNameFormFieldDisplayText, defaultCustomerDetailsPhoneNumberFormFieldDisplayText } from './display-text';
import { CustomerDetailsFormFieldName } from './name';
const defaultGivenNameFieldProps = {
    name: CustomerDetailsFormFieldName.GivenName,
    displayText: defaultCustomerDetailsGivenNameFormFieldDisplayText
};
const defaultFamilyNameFieldProps = {
    name: CustomerDetailsFormFieldName.FamilyName,
    displayText: defaultCustomerDetailsFamilyNameFormFieldDisplayText
};
const defaultEmailFieldProps = {
    name: CustomerDetailsFormFieldName.Email,
    displayText: defaultCustomerDetailsEmailFormFieldDisplayText
};
const defaultPhoneNumberFieldProps = {
    name: CustomerDetailsFormFieldName.PhoneNumber,
    displayText: defaultCustomerDetailsPhoneNumberFormFieldDisplayText
};
export const defaultCustomerDetailsFormFieldPropsProvider = (props) => {
    switch (props.name) {
        case CustomerDetailsFormFieldName.GivenName:
            return defaultGivenNameFieldProps;
        case CustomerDetailsFormFieldName.FamilyName:
            return defaultFamilyNameFieldProps;
        case CustomerDetailsFormFieldName.Email:
            return defaultEmailFieldProps;
        case CustomerDetailsFormFieldName.PhoneNumber:
            return defaultPhoneNumberFieldProps;
        default:
            throw new InvalidFieldNameError('CustomerDetailsFormField', props.name);
    }
};
export const customerDetailsFormFieldPropsValidator = Validator.object({
    name: Validator.oneOf(Object.keys(CustomerDetailsFormFieldName)),
    displayText: customerDetailsFormFieldDisplayTextValidator
});
